import moment from "moment";
import { mask } from "remask";

export const formatCurrency = (value) => {
  return value
    ? new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).format(value / 100)
    : null;
};

export const formatDate = (value) => {
  return value ? moment(value).format("L") : null;
};

export const formatDocument = (value) => {
  return value ? mask(value, ["999.999.999-99", "99.999.999/9999-99"]) : null;
};

export const formatBoolean = (value) => {
  switch (value) {
    case true:
    case "true":
      return "Sim";
    case false:
    case "false":
      return "Não";
  }
};

export const formatPhoneNumber = (value) => {
  return value ? mask(value, ["(99) 9999-9999", "(99) 99999-9999"]) : null;
};

export const formatCep = (value) => {
  return value ? mask(value, ["99.999-999"]) : null;
};

export const sanitizeDocumentName = (value) => {
  return value
    .split(".")[0]
    .replace(/[-_]/g, " ")
    .replace(/\s{2,}/g, " ");
};
